import { FC } from "react";

import TableApplicationFormList from "../../../components/table/recruiting/tableApplicationList";


import styles from './applicationForm.module.scss';

const ApplicationForm: FC = () => {
  return (
    <div className={styles.applicationForm}>
      <TableApplicationFormList />
    </div>
  );
};

export default ApplicationForm;